var $name="getTotalStickyHeight",$path="app/utilities/getTotalStickyHeight.js",$this={$name,$path,};import { css } from 'configs';

import getCSSVariable from './getCSSVariable';
import parseDecimal from './parseDecimal';

const getTotalStickyHeight = () => parseDecimal(getCSSVariable(css.variableNames.totalStickyHeight));

export default getTotalStickyHeight;
